<template>
  <div class="row">
    <div v-for="item in items" :key="item.key" class="col-12 col-md-6 kpi-col mb-3">
      <div class="card executive-kpi h-100">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">            
            <span class="trend" :class="item.growth >= 0 ? 'trend-up' : 'trend-down'">
              {{ item.growth >= 0 ? '↑' : '↓' }} {{ Math.abs(item.growth).toFixed(1) }}%
            </span>
          </div>
          <div class="kpi-title">{{ item.title }}</div>
          <div class="kpi-value">{{ item.value }}</div>
          <div class="kpi-subtext">{{ item.subtext }}</div>
          <div class="kpi-growth-track mt-2">
            <span
              class="kpi-growth-fill"
              :class="item.growth >= 0 ? 'kpi-growth-up' : 'kpi-growth-down'"
              :style="{ width: `${growthWidth(item.growth)}%` }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveKpiCards',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    growthWidth(value) {
      const width = Math.min(Math.abs(value) * 5, 100)
      return Number(width.toFixed(0))
    },
  },
}
</script>

<style scoped>
.executive-kpi {
  border: 1px solid #d8e5ec;
  border-radius: 15px;
  box-shadow: 0 10px 24px rgba(8, 30, 56, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  position: relative;
  overflow: hidden;
}

.executive-kpi::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, rgba(25, 135, 84, 0.85), rgba(15, 89, 126, 0.9));
}

.executive-kpi:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 30px rgba(8, 30, 56, 0.14);
}

.kpi-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.icon-income {
  background: linear-gradient(135deg, #1a9957, #17623f);
}

.icon-user {
  background: linear-gradient(135deg, #0d5a77, #0b3d56);
}

.icon-team {
  background: linear-gradient(135deg, #137c5f, #0d4f3b);
}

.icon-field {
  background: linear-gradient(135deg, #1e7d98, #124f63);
}

.icon-growth {
  background: linear-gradient(135deg, #19734f, #0c4b33);
}

.kpi-title {
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #4f677d;
  font-weight: 700;
}

.kpi-value {
  font-size: 30px;
  line-height: 1.1;
  color: #0c2a40;
  font-weight: 700;
  margin-top: 6px;
  letter-spacing: -0.03em;
}

.kpi-subtext {
  margin-top: 6px;
  color: #6a7f91;
  font-size: 12px;
}

.kpi-growth-track {
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: #e8eff4;
  overflow: hidden;
}

.kpi-growth-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
}

.kpi-growth-up {
  background: linear-gradient(90deg, #19975e, #0d6785);
}

.kpi-growth-down {
  background: linear-gradient(90deg, #d95652, #bf3f35);
}

.trend {
  font-size: 12px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}

.trend-up {
  color: #0f7f41;
  background: #e7f8ed;
}

.trend-down {
  color: #b13634;
  background: #ffefef;
}

@media (min-width: 1200px) {
  .kpi-col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
